function deleteFields(num) {
  const elements = document.getElementsByClassName('attendee-fieldsets');
  while(elements.length > 0){
    elements[0].parentNode.removeChild(elements[0]);
  }
  
  addFields(num);
}

function addFields(num) {
    for (let i = 0; i < num; i++) {
        // create inputs for attendee name, email, phone, salon adress, IG
        // name
        let nameLabel = document.createElement('label');
        nameLabel.for = `Attendee_Name_${i+1}`;
        nameLabel.textContent = 'Name';

        let nameInput = document.createElement('input');
        nameInput.type = "text";
        nameInput.id = `Attendee_Name_${i+1}`;
        nameInput.name=`properties[${i+1}. Attendee Name]`;
        nameInput.required = "true";

        let nameWrap = document.createElement('div');
        nameWrap.classList.add('fieldset', 'line-item-property__field');
        nameWrap.append(nameLabel, nameInput);

        // email
        let emailLabel = document.createElement('label');
        emailLabel.for = `Attendee_Email_${i+1}`;
        emailLabel.textContent = 'Email';
        
        let emailInput = document.createElement('input');
        emailInput.type = "email";
        emailInput.id = `Attendee_Email_${i+1}`;
        emailInput.autocorrect = 'off';
        emailInput.autocapitalize = 'off';
        emailInput.name = `properties[${i+1}. Attendee Email]`;
        emailInput.required = "true";

        let emailWrap = document.createElement('div');
        emailWrap.classList.add('fieldset', 'line-item-property__field');
        emailWrap.append(emailLabel, emailInput);
        
        // phone
        let phoneLabel = document.createElement('label');
        phoneLabel.for = `Attendee_Phone_${i+1}`;
        phoneLabel.textContent = 'Phone Number';

        let phoneInput = document.createElement('input');
        phoneInput.type = 'tel';
        phoneInput.id = `Attendee_Phone_${i+1}`;
        phoneInput.pattern= '[0-9\-]*';
        phoneInput.name = `properties[${i+1}. Attendee Phone]`;
        phoneInput.required = "true";

        let phoneWrap = document.createElement('div');
        phoneWrap.classList.add('fieldset', 'line-item-property__field');
        phoneWrap.append(phoneLabel, phoneInput);

        // salon address
        let salonLabel = document.createElement('label');
        salonLabel.for = `Attendee_Salon_Address_${i+1}`;
        salonLabel.textContent = 'Salon Address';

        let salonInput = document.createElement('input');
        salonInput.type = 'text';
        salonInput.id = `Attendee_Salon_Address_${i+1}`;
        salonInput.name = `properties[${i+1}. Attendee Salon Address]`;
        salonInput.required = "true";

        let salonWrap = document.createElement('div');
        salonWrap.classList.add('fieldset', 'line-item-property__field');
        salonWrap.append(salonLabel, salonInput);

        // city
        let cityLabel = document.createElement('label');
        cityLabel.for = `Attendee_City_${i+1}`;
        cityLabel.textContent = 'City';

        let cityInput = document.createElement('input');
        cityInput.type = 'text';
        cityInput.id = `Attendee_City_${i+1}`;
        cityInput.name = `properties[${i+1}. Attendee City]`;
        cityInput.required = "true";

        let cityWrap = document.createElement('div');
        cityWrap.classList.add('fieldset', 'line-item-property__field');
        cityWrap.append(cityLabel, cityInput);

        // state
        let stateLabel = document.createElement('label');
        stateLabel.for = `Attendee_State_${i+1}`;
        stateLabel.textContent = 'State';

        let stateInput = document.createElement('input');
        stateInput.type = 'text';
        stateInput.id = `Attendee_State_${i+1}`;
        stateInput.name = `properties[${i+1}. Attendee State]`;
        stateInput.required = "true";

        let stateWrap = document.createElement('div');
        stateWrap.classList.add('fieldset', 'line-item-property__field');
        stateWrap.append(stateLabel, stateInput);

        // country
        let countryLabel = document.createElement('label');
        countryLabel.for = `Attendee_Country_${i+1}`;
        countryLabel.textContent = 'Country';

        let countryInput = document.createElement('input');
        countryInput.type = 'text';
        countryInput.id = `Attendee_Country_${i+1}`;
        countryInput.name = `properties[${i+1}. Attendee Country]`;
        countryInput.required = "true";

        let countryWrap = document.createElement('div');
        countryWrap.classList.add('fieldset', 'line-item-property__field');
        countryWrap.append(countryLabel, countryInput);

        // instagram
        let igLabel = document.createElement('label');
        igLabel.for = `Attendee_Instagram_${i+1}`;
        igLabel.textContent = 'Instagram';

        let igInput = document.createElement('input');
        igInput.type = 'text';
        igInput.id = `Attendee_Instagram_${i+1}`;
        igInput.name = `properties[${i+1}. Attendee Instagram]`;

        let igWrap = document.createElement('div');
        igWrap.classList.add('fieldset', 'line-item-property__field');
        igWrap.append(igLabel, igInput);

        // create container for fieldsets
        // name, email, phone, salon adress, IG
        let fieldsetsContainer = document.createElement('div');
        fieldsetsContainer.classList.add('fieldsets-container');
        fieldsetsContainer.append(nameWrap, emailWrap, phoneWrap, salonWrap, cityWrap, stateWrap, igWrap, countryWrap);

        // create header
        let header = document.createElement('h3');
        header.classList.add('attendee-header');
        header.textContent = 'Attendee Information';
      
      	// create required message
      	let message = document.createElement('h5');
      	message.classList.add('h5', 'red');
      	message.textContent = '*Please fill out all attendee information';

        // create parent container
        const parent = document.createElement('div');
        parent.classList.add('attendee-fieldsets');
        parent.id = `attendee-id-${i+1}`;
        parent.append(header, message, fieldsetsContainer);

        // append parent container to attendee info
        const container = document.getElementById('attendee-info');
        container.append(parent);
    }
}

